import React, { Component } from "react"
import ForHealthCoach from "./components/ForHealthCoach"
import ResponseModal from "../blog/blogList/components/shared/blogListForm/components/ResponseModal/ResponseModal"
import axios from "axios"
import LocaleContext from "../../context/LocaleContext"
class ForHealthCoachContainer extends Component {
  constructor() {
    super()
    this.state = {
      activeIncomeProgram: true,
      beOrganizedProgram: false,
      onlineConsultationProgram: false,
      email: "",
      responseModal: false,
      error: "",
      path: "path",
      errors: {},
      loading: false,
      subdomain: "bg",
      preferredLang: "bg-BG",
      isHCP: true,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
  }

  updateWindowDimensions = () => {
    let path = window.location.pathname.slice(1)
    let place = path.search("/", path)
    let result =
      path === "" ? "/" : window.location.pathname.slice(0, place + 600)
    this.setState({ path: result })
  }

  handleEmailChange = event => {
    this.setState({ email: event.target.value })
  }

  handleCloseModal = () => {
    this.setState({ responseModal: false, error: "" })
  }

  validate = () => {
    const { email } = this.state
    let newErrors = {}
    if (email !== "undefined") {
      let pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      )
      if (!pattern.test(email)) {
        newErrors.email = "Моля въведете валиден емайл адрес"
      }
    }
    this.setState({ errors: newErrors })
    return !Object.keys(newErrors).length
  }

  handleSubmit = e => {
    e.preventDefault()
    const { email } = this.state
    let isValid = this.validate()
    if (isValid) {
      this.setState({ loading: true })
      axios
        .post(
          "https://cors-anywhere.herokuapp.com/https://api.dianurse.com/dianurse/v1/contact/subscribe-for-free-access",
          {
            email,
            subdomain: this.state.subdomain,
            preferredLang: this.state.preferredLang,
            isHCP: this.state.isHCP,
          }
        )
        .then(result => {
          this.setState({
            error: result.data,
            responseModal: true,
            loading: false,
          })
        })
    }
  }

  toggleActiveIncomeProgram = () => {
    this.setState({
      activeIncomeProgram: true,
      beOrganizedProgram: false,
      onlineConsultationProgram: false,
    })
  }

  toggleActiveOrganizedProgram = () => {
    this.setState({
      beOrganizedProgram: true,
      activeIncomeProgram: false,
      onlineConsultationProgram: false,
    })
  }

  toggleActiveOnlineConsultationProgram = () => {
    this.setState({
      onlineConsultationProgram: true,
      activeIncomeProgram: false,
      beOrganizedProgram: false,
    })
  }

  render() {
    const {
      activeIncomeProgram,
      beOrganizedProgram,
      onlineConsultationProgram,
      email,
      path,
      errors,
      loading,
    } = this.state
    const {
      healthCoachHeaderImage,
      healthCoachProgramImages,
      healthCoachHelpImages,
      images,
    } = this.props
    const { locale } = this.context
    return (
      <React.Fragment>
        <ForHealthCoach
          locale={locale}
          loading={loading}
          path={path}
          handleChangeEmail={this.handleEmailChange}
          handleSubmit={this.handleSubmit}
          email={email}
          errors={errors}
          images={images}
          healthCoachHelpImages={healthCoachHelpImages}
          healthCoachProgramImages={healthCoachProgramImages}
          healthCoachHeaderImage={healthCoachHeaderImage}
          toggleActiveOnlineConsultationProgram={
            this.toggleActiveOnlineConsultationProgram
          }
          onlineConsultationProgram={onlineConsultationProgram}
          toggleActiveOrganizedProgram={this.toggleActiveOrganizedProgram}
          beOrganizedProgram={beOrganizedProgram}
          activeIncomeProgram={activeIncomeProgram}
          toggleActiveIncomeProgram={this.toggleActiveIncomeProgram}
        />

        {this.state.responseModal === false ? (
          ""
        ) : (
          <ResponseModal
            responseModal={this.state.responseModal}
            closeModal={this.handleCloseModal}
            error={this.state.error}
          />
        )}
      </React.Fragment>
    )
  }
}

ForHealthCoachContainer.contextType = LocaleContext

export default ForHealthCoachContainer
